import React from 'react'
import HeaderTitle from '../../CopyPeopleList/HeaderTitle'
import ReactApexChart from "react-apexcharts";
import './AverageRisk.css';
function AverageRisk() {

    const state = {

        series: [{
            name: "Desktops",
            data: [ 41, 300, 51, 49, 200, 69, 500]
        }],
        options: {
            chart: {
                height: 350,
                type: 'line',
                zoom: {
                    enabled: false
                }
            },
            dataLabels: {
                enabled: false
            },
            stroke: {
                curve: 'straight',
                // lineCap: 'butt',
                colors: undefined,
                width: 1,
                dashArray: 0, 
            },
            markers: {
              size: 5,
              hover: {
                size: 9
              }
            },
            title: {
                text: 'Average Risk Score of the Last 7 Days',
                align: 'left'
            },
            grid: {
                row: {
                    colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                    opacity: 0.5
                },
            },
            xaxis: {
                categories: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
            }
        },


    };
    return (
        <div className='AverageRiskChart'>
            <HeaderTitle title="Average Risk" dir="ltr" />
            <ReactApexChart options={state.options} series={state.series} type="line" height={200} />
    
        </div>
    )
}




export default AverageRisk
